export const RTL_LANGUAGES = new Set([
  'ar',  // Arabic
  'ur',  // Urdu
]);

export function isRtlLanguage(lang: string): boolean{
  return RTL_LANGUAGES.has(lang);
}
